module.exports = __webpack_public_path__ + "static/img/VideoPoster.74fa3fe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/aboutUs/VideoPoster.jpg
// module id = y/6k
// module chunks = 1